<template lang="html">
  <d-form @submit.prevent="submit()">
    <d-list-group flush>
      <d-list-group-item class="p-0">
        <d-form-row>

          <!-- Tempo de Garantia Default -->
          <d-col md="3" class="form-group">
            <label for="feWarrantyDefault">Tempo de Garantia Padrão</label>
            <d-form-input id="feWarrantyDefault" v-model="model.warranty" placeholder="Ano, mês, dias"/>
          </d-col>

          <!-- Tempo Alerta -->
          <d-col md="3" class="form-group">
            <label for="feTempoAlerta">Tempo Alerta ao cliente</label>
            <d-form-input type="number" id="feTempoAlerta" placeholder="Tempo de espera em dias" v-model="model.timeAlert"/>
          </d-col>

        </d-form-row>

        <d-form-row>

          <d-col md="3" class="form-group">
            <label for="feLogo">Logo</label>
            <div class="custom-file mb-3">
              <input type="file" class="custom-file-input" id="feLogo" ref="file" @change="choseFile()"/>
              <label class="custom-file-label" for="feLogo">{{ file.name }}</label>
            </div>
          </d-col>

        </d-form-row>

      </d-list-group-item>
      <d-list-group-item class="px-0">
        <d-form-row>

          <!-- Price reducer -->
          <d-col md="3" class="form-group">
            <label for="feReducer">Preço padrão do redutor</label>
            <d-input-group prepend="R$">
              <input-currency
                model-index="reducer"
                placeholder="0,00"
                :model="model"
              ></input-currency>
            </d-input-group>
          </d-col>

          <!-- Price pelmet -->
          <d-col md="3" class="form-group">
            <label for="fePelmet">Preço padrão Bandô (vertical)</label>
            <d-input-group prepend="R$">
              <input-currency
                model-index="pelmet"
                placeholder="0,00"
                :model="model"
              ></input-currency>
            </d-input-group>
          </d-col>

          <!-- Price pelmet roller-->
          <d-col md="3" class="form-group">
            <label for="fePelmetRoller">Preço padrão Bandô (rolo)</label>
            <d-input-group prepend="R$">
              <input-currency
                model-index="pelmetRoller"
                placeholder="0,00"
                :model="model"
              ></input-currency>
            </d-input-group>
          </d-col>

          <!-- Price motor -->
          <d-col md="3" class="form-group">
            <label for="feMotor">Preço padrão motor</label>
            <d-input-group prepend="R$">
              <input-currency
                model-index="motor"
                placeholder="0,00"
                :model="model"
              ></input-currency>
            </d-input-group>
          </d-col>

        </d-form-row>
      </d-list-group-item>

      <d-list-group-item class="px-0">
        <d-row>
          <d-col>
            <d-button type="submit" class="btn-primary">Salvar</d-button>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import InputCurrency from '_shared/InputCurrency.vue';
import SettingsService from '_services/rest/modules/settings';
import { _LOAD_MODEL_SETTING_, SETTINGS } from './SettingsModel';

export default {
  name: 'settings-form',
  components: {
    InputCurrency,
  },
  data() {
    return {
      file: { name: 'Escolha uma imagem...' },
      model: { ...SETTINGS },
    };
  },
  watch: {},
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    choseFile() {
      [this.file] = this.$refs.file.files;
      this.model.logo = this.file.name;
    },
    save() {
      this.setSettingToString();
      SettingsService.saveOptions(this.model, 'settings')
        .then(() => this.activeAlert({ message: 'Variáveis salvas com sucesso', theme: 'success' }))
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        })
        .finally(this.loading = false);
    },
    setSettingToString() {
      this.model.motor = this.model.motor.toString();
      this.model.pelmet = this.model.pelmet.toString();
      this.model.reducer = this.model.reducer.toString();
      this.model.pelmetRoller = this.model.pelmetRoller.toString();
    },
    submit() {
      this.loading = true;
      const { settings } = this.$store.state.settings;
      if (this.file.name !== settings.logo) {
        return this.uploadLogoFile();
      }
      return this.save();
    },
    uploadLogoFile() {
      SettingsService.upload(this.file)
        .then(response => {
          this.model.logo = response.path;
          this.file.name = this.model.logo;
          this.save();
        });
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_SETTING_, newValue => {
      this.model = { ...newValue };
      this.file.name = this.model.logo;
    });
  },
};
</script>

<style lang="scss" scoped>
.custom-file-label {
  overflow: hidden;
  white-space: nowrap;
}
</style>
